import { AdPlacement } from "@/components/ads/AdPlacement";
import { ThumbnailGrabber } from "../components/ThumbnailGrabber";
import { YtBreadcrumb } from "../components/YtBreadcrumb";
import { YtExplainer } from "../components/YtExplainer";
import { YtMoreLinks } from "../components/YtMoreLinks";
import type { YtVariant } from "../lib/variants";

/** Generic page for a keyword variant (HD, Shorts), rendered from its config. */
export function VariantPage({ variant }: { variant: YtVariant }) {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <YtBreadcrumb current={variant.navName()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {variant.h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {variant.intro()}
          </p>
        </header>

        <ThumbnailGrabber highlight={variant.highlight} />

        <YtExplainer
          howTo={variant.howTo()}
          faqs={variant.faqs.map((f) => ({ q: f.q(), a: f.a() }))}
        />

        <AdPlacement className="mt-10" />
        <YtMoreLinks currentSlug={variant.slug} />
      </div>
    </div>
  );
}
